// Zentrale Marketing-Vorlagen (StrongFit schwarz/gold) — genutzt im Marketing-Composer.
// WICHTIG (06/2026): Die Vorlagen bringen KEINEN eigenen Außenrand / keine
// max-width-Kappung mehr mit. Sie fliessen direkt in den einheitlichen
// StrongFit-Mail-Rahmen (Logo-Header + schwarzer Hintergrund + einstellbarer,
// responsiver Seitenrand aus email_service._wrap_email_html). Dadurch wirkt der
// Inhalt auf dem Handy nicht mehr winzig zusammengequetscht.
const ALEX_WA_NUMBER_DISPLAY = '+41 79 696 98 99';
const ALEX_WA_LINK = 'https://wa.me/41796969899?text=' + encodeURIComponent(
  'Hallo StrongFit, ich möchte etwas Verdächtiges melden (Termin ohne Grund abgesagt / komische Mail oder WhatsApp).'
);
const ALEX_EMAIL = 'info@strongfit.ch';

const SECURITY_NOTICE_HTML = `<div style="font-family:Arial,Helvetica,sans-serif;">
  <div style="background-color:#F59E0B;background:#F59E0B;background-image:linear-gradient(135deg,#FFD700 0%,#F59E0B 100%);padding:18px 22px;border-radius:12px;margin:0 0 22px;">
    <div style="margin:0;color:#0a0a0a;font-size:20px;font-weight:800;">🔒 Sicherheitshinweis</div>
  </div>
  <p style="font-size:16px;line-height:1.6;margin:0 0 16px;">Hallo {first_name} 👋</p>
  <p style="font-size:16px;line-height:1.6;margin:0 0 16px;">Kurz und wichtig: <strong style="color:#FFD700;">Melde dich bitte SOFORT bei uns</strong>, wenn</p>
  <ul style="font-size:15px;line-height:1.7;margin:0 0 20px;padding-left:20px;">
    <li>ein Training <strong>ohne Grund</strong> abgesagt wurde – weder von dir noch von uns,</li>
    <li>du eine <strong>ungewöhnliche oder komische E-Mail bzw. WhatsApp</strong> in unserem Namen bekommst.</li>
  </ul>
  <p style="font-size:15px;line-height:1.6;margin:0 0 20px;color:#a0a0a0;">So können wir sofort reagieren und dich schützen. Lieber einmal zu viel melden als zu wenig – danke dir! 🙏</p>
  <p style="font-size:15px;line-height:1.6;margin:0 0 24px;">Und für <strong style="color:#FFD700;">Änderungen, Anpassungen oder Fehler</strong> in der App: melde dich bitte ebenfalls direkt bei Alex – am einfachsten mit einem kurzen <strong>Screenshot</strong> oder einer <strong>Sprachnachricht</strong>.</p>
  <div style="text-align:center;margin:0 0 14px;">
    <a href="${ALEX_WA_LINK}" style="display:inline-block;background:#25D366;color:#ffffff;text-decoration:none;font-weight:700;font-size:16px;padding:14px 26px;border-radius:10px;">📱 Jetzt direkt Alex auf WhatsApp melden</a>
  </div>
  <p style="text-align:center;font-size:13px;color:#a0a0a0;margin:0 0 22px;">oder ${ALEX_WA_NUMBER_DISPLAY} · <a href="mailto:${ALEX_EMAIL}" style="color:#FFD700;">E-Mail schreiben</a></p>
  <p style="font-size:14px;line-height:1.6;margin:0;">Sportliche Grüsse<br/><strong>Dein StrongFit-Team</strong></p>
</div>`;

const _releaseFeature = (icon, title, text) => `
      <tr>
        <td style="vertical-align:top;padding:10px 12px 10px 0;font-size:22px;">${icon}</td>
        <td style="vertical-align:top;padding:10px 0;">
          <p style="margin:0 0 3px;color:#FFD700;font-size:15px;font-weight:700;">${title}</p>
          <p style="margin:0;color:#a0a0a0;font-size:14px;line-height:1.55;">${text}</p>
        </td>
      </tr>`;

const SOFTWARE_RELEASE_HTML = `<div style="font-family:Arial,Helvetica,sans-serif;">
  <div style="background-color:#F59E0B;background:#F59E0B;background-image:linear-gradient(135deg,#FFD700 0%,#F59E0B 100%);padding:18px 22px;border-radius:12px;margin:0 0 22px;">
    <div style="margin:0;color:#0a0a0a;font-size:20px;font-weight:800;">Deine neue App 🚀</div>
  </div>
  <p style="font-size:16px;line-height:1.6;margin:0 0 16px;">Hallo {first_name} 👋</p>
  <p style="font-size:16px;line-height:1.6;margin:0 0 22px;">Wir haben unsere <strong style="color:#FFD700;">StrongFit-App</strong> komplett aufgewertet – damit du dein Training, deine Ernährung und alles Rundherum ganz easy im Griff hast. Das ist neu für dich:</p>
  <table role="presentation" cellpadding="0" cellspacing="0" style="width:100%;border-collapse:collapse;margin:0 0 8px;">
    ${_releaseFeature('📸', 'Ernährung per Foto tracken', 'Einfach dein Essen fotografieren – die App erkennt Kalorien &amp; Makros automatisch.')}
    ${_releaseFeature('⏱️', 'Warteliste für Termine', 'Slot ausgebucht? Setz dich auf die Warteliste und rücke automatisch nach.')}
    ${_releaseFeature('💳', 'Kosten &amp; Abos im Griff', 'Dein Abo, dein Guthaben und alle Zahlungen übersichtlich an einem Ort.')}
    ${_releaseFeature('📅', 'Termine selbst buchen &amp; verschieben', 'Buche, verschiebe oder storniere deine Trainings bequem selbst – rund um die Uhr.')}
    ${_releaseFeature('⭐', 'Punkte &amp; Guthaben', 'Behalte deine Punkte und dein Guthaben im Blick und setze sie flexibel ein.')}
  </table>
  <div style="text-align:center;margin:24px 0 14px;">
    <a href="{booking_link}" style="display:inline-block;background:#F59E0B;color:#0a0a0a;text-decoration:none;font-weight:700;font-size:16px;padding:14px 28px;border-radius:10px;">Jetzt App öffnen</a>
  </div>
  <p style="font-size:14px;line-height:1.6;margin:0;">Sportliche Grüsse<br/><strong>Dein StrongFit-Team</strong></p>
</div>`;

const APERO_HTML = `<div style="font-family:Arial,Helvetica,sans-serif;">
  <div style="background-color:#F59E0B;background:#F59E0B;background-image:linear-gradient(135deg,#FFD700 0%,#F59E0B 100%);padding:18px 22px;border-radius:12px;margin:0 0 22px;">
    <div style="margin:0;color:#0a0a0a;font-size:20px;font-weight:800;">Rapperswil · Eröffnung 🥂</div>
  </div>
  <p style="font-size:16px;line-height:1.6;margin:0 0 16px;">Hallo {first_name} 👋</p>
  <p style="font-size:16px;line-height:1.6;margin:0 0 18px;">Unser neues Studio in <strong style="color:#FFD700;">Rapperswil-Jona</strong> ist ab sofort buchbar – und wir feiern das mit dir!</p>
  <p style="background:#0f2d29;border-left:4px solid #F59E0B;padding:12px 16px;font-size:15px;margin:0 0 20px;border-radius:8px;"><strong style="color:#FFD700;">🥂 Eröffnungs-Apéro: {apero_date}</strong><br/>Komm auf Getränke &amp; Apéro vorbei – wir zeigen dir das neue Studio!</p>
  <div style="text-align:center;margin:0 0 14px;">
    <a href="{booking_link}" style="display:inline-block;background:#F59E0B;color:#0a0a0a;text-decoration:none;font-weight:700;font-size:16px;padding:14px 28px;border-radius:10px;">Jetzt Probetraining buchen</a>
  </div>
  <p style="font-size:14px;line-height:1.6;margin:18px 0 0;">Sportliche Grüsse<br/><strong>Dein StrongFit-Team</strong></p>
</div>`;

const PREREG_DISCOUNT_SUBJECT = 'Dein Willkommens-Geschenk: 10% Rabatt – ein Leben lang 🎉';
const PREREG_DISCOUNT_HTML = `<div style="font-family:Arial,Helvetica,sans-serif;">
  <div style="text-align:center;margin:0 0 24px;">
    <div style="color:#F59E0B;font-size:12px;font-weight:700;letter-spacing:3px;text-transform:uppercase;margin:0 0 12px;">StrongFit · Nur für Vorregistrierte</div>
    <div style="color:#ffffff;font-size:26px;font-weight:800;line-height:1.2;margin:0 0 10px;">Danke, dass du von Anfang an dabei bist</div>
    <div style="color:#c9c9c9;font-size:16px;line-height:1.55;margin:0;">Als Dankeschön für deine Vorregistrierung haben wir etwas Besonderes für dich.</div>
  </div>
  <p style="font-size:16px;line-height:1.7;margin:0 0 22px;color:#d0d0d0;">Hallo {first_name} 👋<br/><br/>
    Du hast dich schon vor der Eröffnung von <strong style="color:#F59E0B;">StrongFit Rapperswil-Jona</strong> registriert &mdash; und genau das belohnen wir. Dein persönliches Willkommens-Geschenk:</p>
  <div style="background-image:linear-gradient(135deg,#FFD700 0%,#F59E0B 100%);background-color:#F59E0B;border-radius:16px;padding:26px 22px;text-align:center;margin:0 0 24px;">
    <div style="color:#0a0a0a;font-size:14px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;margin:0 0 6px;">Dein Vorteil</div>
    <div style="color:#0a0a0a;font-size:46px;font-weight:900;line-height:1;margin:0 0 6px;">10%</div>
    <div style="color:#0a0a0a;font-size:18px;font-weight:800;margin:0;">Rabatt &mdash; ein Leben lang</div>
  </div>
  <p style="font-size:15px;line-height:1.75;margin:0 0 26px;color:#d0d0d0;">
    Die <strong style="color:#ffffff;">10% gelten dauerhaft</strong> auf deine StrongFit-Mitgliedschaft &mdash; solange du dabei bist. Kein Aktionscode, keine Frist: Wir hinterlegen deinen Rabatt automatisch bei deiner Anmeldung.
  </p>
  <div style="text-align:center;margin:0 0 28px;">
    <a href="{booking_link}" style="display:inline-block;background:#F59E0B;color:#0a0a0a;text-decoration:none;font-weight:800;font-size:16px;padding:15px 34px;border-radius:10px;">Jetzt Mitgliedschaft sichern →</a>
  </div>
  <div style="border-top:1px solid #232323;padding-top:20px;">
    <p style="font-size:15px;line-height:1.6;margin:0;">Bis bald im Studio!<br/><strong style="color:#ffffff;">Dein StrongFit-Team</strong></p>
  </div>
</div>`;

export const MARKETING_PRESETS = [
  // 🎉 Für neue Interessenten / Vorregistrierte
  { key: 'apero', audience: 'interessenten', icon: '🥂', label: 'Rapperswil-Apéro', subject: '🥂 Eröffnung StrongFit Rapperswil – du bist eingeladen!', html: APERO_HTML },
  { key: 'prereg', audience: 'interessenten', icon: '🎉', label: '10% lebenslang (Vorregistrierte)', subject: PREREG_DISCOUNT_SUBJECT, html: PREREG_DISCOUNT_HTML },
  // 💛 Für Bestandskunden
  { key: 'security', audience: 'bestand', icon: '🔒', label: 'Sicherheitshinweis', subject: '🔒 Wichtiger Sicherheitshinweis von StrongFit – bitte kurz lesen', html: SECURITY_NOTICE_HTML },
  { key: 'release', audience: 'bestand', icon: '🚀', label: 'Neue App vorstellen', subject: 'Deine neue StrongFit-App ist da! 🚀', html: SOFTWARE_RELEASE_HTML },
];

export const PRESET_GROUPS = [
  { audience: 'interessenten', label: '🎉 Für neue Interessenten / Vorregistrierte' },
  { audience: 'bestand', label: '💛 Für Bestandskunden' },
];

// Vorschau-Hülle — spiegelt den echten Mail-Rahmen aus
// email_service._wrap_email_html (Logo-Header, schwarzer Hintergrund,
// einstellbarer + responsiver Seitenrand). Damit zeigt die Composer-Vorschau
// exakt das, was der Empfänger sieht (WYSIWYG). `sidePadding` = Desktop-Rand;
// auf schmalen Screens wird er automatisch halbiert.
export const renderMarketingPreview = (bodyHtml, sidePadding = 24, brandName = '', logoUrl = '') => {
  const pad = Math.max(0, Math.min(48, Number(sidePadding) || 24));
  const padMobile = Math.max(8, Math.round(pad * 0.5));
  const brand = (brandName || '').trim() || 'Studio';
  const logo = (logoUrl || '').trim();
  return `<!DOCTYPE html><html lang="de"><head><meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
<style>
  html,body{margin:0;padding:0;background:#0a0a0a;}
  .sf-head,.sf-body,.sf-foot{padding-left:${pad}px;padding-right:${pad}px;}
  .sf-body p{color:#ffffff;line-height:1.7;}
  .sf-body a:not([style*="padding"]){color:#facc15;}
  @media only screen and (max-width:480px){
    .sf-head,.sf-body,.sf-foot{padding-left:${padMobile}px !important;padding-right:${padMobile}px !important;}
  }
</style></head>
<body style="margin:0;padding:0;background:#0a0a0a;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;color:#ffffff;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#0a0a0a;">
    <tr><td align="center">
      <table role="presentation" width="600" cellspacing="0" cellpadding="0" style="max-width:600px;width:100%;background:#0a0a0a;">
        <tr><td class="sf-head" style="padding-top:40px;padding-bottom:24px;text-align:center;">
          ${logo
            ? `<img src="${logo}" alt="${brand}" style="max-height:72px;max-width:260px;height:auto;display:inline-block;"/>`
            : `<span style="font-size:26px;font-weight:700;color:#ffffff;letter-spacing:0.5px;">${brand}</span>`}
        </td></tr>
        <tr><td class="sf-body" style="padding-top:24px;padding-bottom:32px;color:#ffffff;font-size:15px;line-height:1.7;">
          ${bodyHtml}
        </td></tr>
        <tr><td class="sf-foot" style="padding-top:24px;padding-bottom:40px;text-align:center;color:#9ca3af;font-size:12px;border-top:1px solid #1f1f1f;">
          &copy; ${new Date().getFullYear()} ${brand}. Diese E-Mail wurde automatisch generiert.
        </td></tr>
      </table>
    </td></tr>
  </table>
</body></html>`;
};
